import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function JungleCruiseStart() {
  const dateTexts = ['1931年', '10月', '1日'];
  const title = 'ジャングルクルーズ開始';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2021/12/alberta-falls.jpg'
  const description = (
    <>
      <a href='/albert-falls'>
        {'フォールズ博士'}
      </a>
      {'の孫娘アルバータが、経営不振であった祖父の会社を立て直すために、会社の船を利用してジャングルクルーズを開始する。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      objectPosition='10%'
    />
  );
}

export default JungleCruiseStart;
